module.exports = __webpack_public_path__ + "static/media/logo-vertical.7c77efdb.svg";